import React from "react";
import { setLocationsInfo } from "../../state/actions/app";
import { connect } from 'react-redux';

const mapStateAsProps = (state) => ({
    locationsInfo: state.locationsState.locations
})

const mapDispatchAsProps = dispatch => ({
    setLocationsInfo: () => dispatch(setLocationsInfo(null))
})

const LocationsModal = (props) => {
        console.log(props)
        if(!props.locationsInfo) return null
        const { library, locations , version} = props.locationsInfo
        return (
            <div className="modal fade user-modal" id="license-display-modal" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Locations of {library.displayName} {version}</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <div >
                                {locations.length?
                                    <ul>
                                        {locations.map((location, index)=>(
                                            <li key={"location-"+index}>{location}</li>
                                        ))}
                                    </ul>
                                : <p>No locations found.</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

export default connect(mapStateAsProps, mapDispatchAsProps)(LocationsModal)